class AutomatedManualSelection {
    constructor() {
        this.init();
    }

    init() {
        this.waitForElementsByQuerySelectorAll('.apo-option-group', () => {
            if (document.querySelector('.apo-group-accordion')) {
                // Accordion Found
                console.log("init called")
                this.processOptions('.apo-group-accordion', '[Automated]', 'apo-automated' )
                this.processOptions('.apo-group-accordion', '[Manual]', 'apo-manual')
                this.showAllOptions()
                this.defaultOptions();
                this.setupEventListeners();
                this.reFormNumberSteps()
            } else {
                console.log("Custom APO - [No Accordion Found]")
            }
        });
    }

    showAllOptions() {
        document.querySelectorAll('.apo-automated').forEach(item => {
            // Remove the display property
            item.style.removeProperty('display');
        });
        document.querySelectorAll('.apo-manual').forEach(item => {
            // Remove the display property
            item.style.removeProperty('display');
        })

    }

    processOptions(selector, keyword, className) {
        document.querySelectorAll(selector).forEach(item => {
            if (item.innerHTML.includes(keyword)) {
                const accordionParent = item.closest('.apo-group-accordion');
                if (accordionParent) {
                    accordionParent.style.display = 'none';
                    accordionParent.classList.add(className);
                }
                const nestedDiv = item.querySelector('.apo-title');

                if (nestedDiv) {
                    console.log("Nested div with class 'apo-title':", nestedDiv);
                    // Update the inner text of the nested div
                    nestedDiv.innerText = nestedDiv.innerText.replace(keyword, '').trim();
                } else {
                    console.log("No nested div with class 'apo-title' found.");
                }
            }
            // console.log(item.innerHTML);
        });
    }

    hideAllOptions(className) {
        document.querySelectorAll(`.${className}`).forEach(item => {
            item.style.display = 'none';
        });
    }

    showAllOptions(className) {
        document.querySelectorAll(`.${className}`).forEach(item => {
            item.style.removeProperty('display');
        });
    }

    defaultOptions() {
        this.showAllOptions('apo-manual');
        this.hideAllOptions('apo-automated');
        const choices = document.querySelectorAll('.mechanism-type .ap-options__button .avp-productoptioncheckwrapper span.choice-list-variatnt-title');
        choices.forEach(choice => {
            if(choice.innerText.trim() === "Manual") {
                choice.previousElementSibling.checked = true;
                console.log("checked?", choice.previousElementSibling.checked);
                const automatedChoice = Array.from(choices).find(c => c.innerText.trim() === "Automated");
                if (automatedChoice) {
                    automatedChoice.previousElementSibling.checked = false;
                }
            }
        });
        // this.reFormNumberSteps();
    }

    setupEventListeners() {
        const choices = document.querySelectorAll('.mechanism-type .ap-options__button .avp-productoptioncheckwrapper span.choice-list-variatnt-title');
        choices.forEach(choice => {
            choice.addEventListener('click', () => {
                const innerText = choice.innerText.trim();
                if (innerText === "Automated") {
                    // Uncheck the manual option
                    const manualChoice = Array.from(choices).find(c => c.innerText.trim() === "Manual");
                    if (manualChoice) {
                        manualChoice.previousElementSibling.checked = false;
                    }
                    choice.previousElementSibling.checked = true;
                    // console.log("Automated Fired");
                    // console.log(innerText);
                    this.showAllOptions('apo-automated');
                    this.hideAllOptions('apo-manual');
                    this.reFormNumberSteps();
                } else if (innerText === "Manual") {
                    // Uncheck the automated option
                    const automatedChoice = Array.from(choices).find(c => c.innerText.trim() === "Automated");
                    if (automatedChoice) {
                        automatedChoice.previousElementSibling.checked = false;
                    }
                    choice.previousElementSibling.checked = true;
                    // console.log("Manual Fired");
                    this.showAllOptions('apo-manual');
                    this.hideAllOptions('apo-automated');
                    this.reFormNumberSteps();
                }
            });
        });
    }

    reFormNumberSteps() {
            // Select all step-circle elements
        const stepCircles = document.querySelectorAll('.step-circle');

        // Create an array to store the valid step elements
        const validSteps = [];

        // Loop through each step-circle
        stepCircles.forEach(circle => {
            // Find the nearest .ap-options__optiongroup-container or the nearest gate-installation-inquiry-form-group
            const optionGroupContainer = circle.closest('.ap-options__optiongroup-container');
            const inquiryGroupContainer = circle.closest('#gate-installation-inquiry-form-group');

            // Check if either container exists and if its display style is not set to 'none'
            const isOptionGroupVisible = optionGroupContainer && optionGroupContainer.style.display !== 'none';
            const isInquiryGroupVisible = inquiryGroupContainer && inquiryGroupContainer.style.display !== 'none';

            // If either of the containers is visible, add to valid steps
            if (isOptionGroupVisible || isInquiryGroupVisible) {
                validSteps.push(circle); // Add the valid step-circle to the array
            }
        });

        // Set the inner text of each valid step-circle to its index + 1
        validSteps.forEach((step, index) => {
            step.innerText = (index + 1).toString(); // Set the inner text to index + 1
        });

        // You can log validSteps to see which elements were updated
        console.log(validSteps); // This will log the filtered step-circle elements 
    }

    waitForElementByQuerySelector(selector, callback) {
        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);
            if (element) {
                observer.disconnect(); // Stop observing once the element is found
                callback(element); // Call the callback with the found element
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }

    waitForElementsByQuerySelectorAll(selector, callback) {
        const observer = new MutationObserver(() => {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                observer.disconnect(); // Stop observing once elements are found
                callback(elements); // Call the callback with the found elements
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }

}

// Instantiate the class to run the code
 new AutomatedManualSelection();
